module.exports = __webpack_public_path__ + "media/images/full_height-cb404fa5c2f7a3680985a149b7c9c20c.jpg";